export const AUTH0_ORIGIN_URL = process.env
  .REACT_APP_AUTH0_ORIGIN_URL as string;
export const AUTH0_ROLES_KEY = process.env.REACT_APP_AUTH0_ROLES_KEY as string;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID as string;
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN as string;
export const SUBDOMAIN_NAME = process.env.REACT_APP_SUBDOMAIN_NAME as string;
export const REACT_APP_FULLSTORY_ORG_ID = process.env
  .REACT_APP_FULLSTORY_ORG_ID as string;
